export default __webpack_public_path__ + "b5c32b2f5c8d71a8d9d2b8d5acc0929d.svg";